import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Link from '@material-ui/core/Link';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import Actions from '../../actions';

import VideoExercise from './VideoExercise';
import Modal from '../Modals/Modal';
import Question from '../Views/Question';
import Snackbar from '../Progress/Snack';
import Loader from '../Progress/Loader';
import TitleBar from '../App/TitleBar';
import DialogBox from '../App/DialogBox';

import { VIDEO_URL_ROUTES } from '../../utils/constants';

const useStyles = makeStyles((theme) => {
  return {
    table: {
      width: '100%',
      boxShadow: theme.boxShadow,
    },
    quiz: {
      marginBottom: 8,
      marginTop: 8,
    },
    container: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    wrapText: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '100px',
    },
  };
});

function VideoTask(props) {
  const {
    getVideoExercises, videoExercises, fetching, insertOrUpdateVideoExercise, deleteVideoExercise,
  } = props;
  const classes = useStyles();

  const [refresh, setRefresh] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [quizes, setQuizes] = React.useState([]);
  const [editVideoExercise, setEditVideoExercise] = React.useState({});
  const [deleteVideoExerciseObj, setDeleteVideoExercise] = React.useState({});
  const [snack, setSnack] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const pageRefresh = () => {
    setRefresh(!refresh);
  };

  const editExercise = (obj) => {
    setEditVideoExercise(obj);
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth',
      });
    }, 5);
  };

  const onClose = () => {
    setOpen(false);
    setQuizes([]);
  };

  const openQuizes = (quizObjs) => {
    setQuizes(quizObjs);
    setOpen(true);
  };

  const closeSnack = () => {
    setSnack({});
  };

  const deleteExercise = (obj) => {
    setDeleteVideoExercise(obj);
    setOpenDialog(true);
  };

  const closeDelete = () => {
    setDeleteVideoExercise({});
    setOpenDialog(false);
  };

  const confirmDelete = () => {
    setLoading(true);
    setOpenDialog(false);
    deleteVideoExercise({ _id: deleteVideoExerciseObj._id })
      .then(() => {
        setSnack({
          open: true,
          severity: 'success',
          message: 'Video Exercise Deleted Successfully.',
        });
        setLoading(false);
        closeDelete();
        pageRefresh();
      }).catch((err) => {
        setSnack({
          open: true,
          severity: 'error',
          message: err.message || (err.error.response.data && err.error.response.data.message) || 'Something went wrong',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getVideoExercises();
  }, [getVideoExercises, refresh]);

  return (
    <>
      <Snackbar
        open={snack.open}
        message={snack.message}
        severity={snack.severity}
        handleClose={closeSnack}
      />
      <DialogBox
        open={openDialog}
        title="Delete Video Exercise"
        confirm={confirmDelete}
        onClose={closeDelete}
      >
        Are you sure want to delete this video exercise?
      </DialogBox>
      <Loader loading={loading || fetching} />
      <Modal open={open} handleClose={onClose} title="View Quizes">
        {
          quizes.map((quiz, index) => {
            return (
              <Grid
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={classes.quiz}
              >
                <Question
                  quizObj={quiz}
                  disabled
                />
              </Grid>
            );
          })
        }
      </Modal>
      <Grid container>
        <Grid item xs={12}>
          <TitleBar title={editVideoExercise._id ? 'Update Video Exercise' : 'Add Video Exercise'} />
        </Grid>
        <Grid item xs={12} className={classes.container}>
          <VideoExercise
            setSnack={setSnack}
            pageRefresh={pageRefresh}
            videoExercise={editVideoExercise}
            setLoading={setLoading}
            insertOrUpdateVideoExercise={insertOrUpdateVideoExercise}
          />
        </Grid>
        <Grid item xs={12}>
          <TitleBar title="Added Video Exercises" />
        </Grid>
        <Grid item xs={12} className={classes.container}>
          <TableContainer component={Paper} elevation={0}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>URL</b></TableCell>
                  <TableCell><b>Quizes</b></TableCell>
                  <TableCell><b>Route</b></TableCell>
                  <TableCell><b>Type</b></TableCell>
                  <TableCell align="center"><b>Edit</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                videoExercises && videoExercises.map((obj) => {
                  const videoRouteObj = VIDEO_URL_ROUTES.find((routeobj) => { return routeobj._id === obj.route; });
                  return (
                    <TableRow key={obj._id}>
                      <TableCell>
                        <Tooltip arrow TransitionComponent={Zoom} title={obj.name}>
                          <div className={classes.wrapText}>
                            {obj.name}
                          </div>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip arrow TransitionComponent={Zoom} title={obj.url}>
                          <div className={classes.wrapText}>
                            <Link underline="none" href={obj.url} target="_blank">{obj.url}</Link>
                          </div>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Button size="small" onClick={() => { openQuizes(obj.quizes); }}>
                          View Quizes
                        </Button>
                      </TableCell>
                      <TableCell>
                        <Tooltip arrow TransitionComponent={Zoom} title={(videoRouteObj && videoRouteObj.name) || ''}>
                          <div className={classes.wrapText}>
                            {videoRouteObj && videoRouteObj.name}
                          </div>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        {obj.type}
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={() => { deleteExercise(obj); }}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => { editExercise(obj); }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
            }
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    videoExercises: state.videoExercises.data,
    fetching: state.videoExercises.fetching,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoTask);
